import { useEffect, useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'
import type { NavId, Transaction, Card } from '../types'
import { useRouter } from './useRouter'

const MONTHS = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro']
const currentYear = new Date().getFullYear()
const currentMonthName = () => MONTHS[new Date().getMonth()]

export function useAppUI(): {
  active: NavId
  setActive: Dispatch<SetStateAction<NavId>>
  navigate: (navId: NavId) => void
  sheetOpen: boolean
  setSheetOpen: Dispatch<SetStateAction<boolean>>
  editingTx: Transaction | null
  setEditingTx: Dispatch<SetStateAction<Transaction | null>>
  faturaCard: Card | null
  setFaturaCard: Dispatch<SetStateAction<Card | null>>
  month: string
  annualYear: number
  setAnnualYear: Dispatch<SetStateAction<number>>
  currentMonthIndex: number
  isCurrentMonth: boolean
  handleSheetClose: () => void
  handleEditClick: (t: Transaction) => void
  prevMonth: () => void
  nextMonth: () => void
  goToCurrentMonth: () => void
} {
  const { active, navigate: routerNavigate, setActive } = useRouter()
  const [sheetOpen,  setSheetOpen]  = useState(false)
  const [editingTx,  setEditingTx]  = useState<Transaction | null>(null)
  const [faturaCard, setFaturaCard] = useState<Card | null>(null)
  const [month,      setMonth]      = useState(currentMonthName)
  const [annualYear, setAnnualYear] = useState(currentYear)

  const idx               = MONTHS.indexOf(month)
  const currentMonthIndex = idx + 1
  const isCurrentMonth    = month === currentMonthName()

  useEffect(() => {
    setMonth(currentMonthName())
  }, [active])

  function handleSheetClose() {
    setSheetOpen(false)
    setEditingTx(null)
  }

  function handleEditClick(t: Transaction) {
    setEditingTx(t)
    setSheetOpen(true)
  }

  function navigate(navId: NavId) {
    routerNavigate(navId)
    setMonth(currentMonthName())
  }

  const prevMonth = () => setMonth(MONTHS[Math.max(0, idx - 1)])
  const nextMonth = () => setMonth(MONTHS[Math.min(11, idx + 1)])
  const goToCurrentMonth = () => setMonth(currentMonthName())

  return {
    active,
    setActive,
    navigate,
    sheetOpen,
    setSheetOpen,
    editingTx,
    setEditingTx,
    faturaCard,
    setFaturaCard,
    month,
    annualYear,
    setAnnualYear,
    currentMonthIndex,
    isCurrentMonth,
    handleSheetClose,
    handleEditClick,
    prevMonth,
    nextMonth,
    goToCurrentMonth,
  }
}
